module.exports = __webpack_public_path__ + "img/69.1.a828607d.jpg";